module.exports = __webpack_public_path__ + "static/media/goalsBg.52cc9a72.png";